module.exports = __webpack_public_path__ + "../resources/images/noSelection-32ecdcb31a947d39b2477558a29511be.svg";